import { findAll } from "@/services/local/potential-spaces-service.js";
import { transformCategoriesToString } from "@/utils/categories";
import { SlugEnum } from "../domains/therapy/steps/mount-sequence/domain/slug-enum";

const state = {
  potentialSpaces: [],
  selected: {},
  relatedParesOfSelected: [],
};

const mutations = {
  setPotentialSpaces(state, value) {
    state.potentialSpaces = value;
  },
  setSelected(state, value) {
    state.selected = value;
  },
  setRelatedParesOfSelected(state, newValue) {
    state.relatedParesOfSelected = newValue;
  },
};

const actions = {
  async load({ commit }) {
    const response = await findAll();
    commit("setPotentialSpaces", response);
  },
  selectOne({ commit, dispatch, rootState }, value) {
    let addedItems = [];

    var isSelected = rootState.diagnosis.diagnose.potentialSpaces.some(
      (diagnosePotentialSpace) =>
        diagnosePotentialSpace.potentialSpace.id === value.id &&
        diagnosePotentialSpace.potentialSpace.slug === SlugEnum.POTENTIAL_SPACE
    );

    if (isSelected) {
      addedItems = rootState.diagnosis.diagnose.potentialSpaces.map(
        (diagnosePotentialSpace) => diagnosePotentialSpace.resolutionZone.id
      );
    }

    commit("setSelected", value);
    dispatch(
      "resolutionZones/showDialog",
      {
        returnAction: "potentialSpaces/handleReturnResolutionZone",
        validateAction: "potentialSpaces/verifyIfAlreadyAdded",
        addedItems: addedItems,
      },
      { root: true }
    );
  },
  async handleReturnResolutionZone(
    { state, commit, dispatch },
    {
      therapistComments,
      patientComments,
      resolutionZone,
      affectedSpotParTrauma,
      trackingPointSide,
      impactionPointSide,
      parTraumaSide,
      hidePatient,
      patientImpactAtHome,
    }
  ) {
    const title = "Checar associações patogênicas";
    const message = `Recomendamos que o sejam checadas as associações patogências deste espaço potencial.
    
    Associações patogênicas: ${transformCategoriesToString(
      state.selected.categories
    )}
    
    Instruções: ${state.selected.instructions}
    
    Deseja checar?`;

    const responseCheckCategories = await dispatch(
      "settings/openConfirm",
      { title, message },
      { root: true }
    );

    const diagnose = {
      potentialSpace: state.selected,
      resolutionZone,
      therapistComments,
      patientComments,
      checkedCategories: responseCheckCategories,
      diagnoseResolutionZone: {
        resolutionZone,
        affectedSpotParTrauma,
        trackingPointSide,
        impactionPointSide,
        parTraumaSide,
      },
      hidePatient,
      patientImpactAtHome,
    };

    commit("diagnosis/addPotentialSpace", diagnose, { root: true });

    if (responseCheckCategories) {
      const ids = state.selected.categories.map((category) => category.id);
      dispatch(
        "checkCategories/startByIds",
        { ids, selectedType: "potentialSpaces" },
        { root: true }
      );
    }
  },
  verifyIfAlreadyAdded: function ({ state, rootState }, { resolutionZone }) {
    return new Promise((resolve, reject) => {
      const exists = rootState.diagnosis.diagnose.potentialSpaces.some(
        (diagnose) =>
          diagnose.potentialSpace.id === state.selected.id &&
          diagnose.resolutionZone.id === resolutionZone.id
      );
      if (exists) {
        reject({
          message:
            "Combinação de Espaço Potencial e Zona de Resolução já adicionado ao diagnóstico.",
        });
      }
      resolve();
    });
  },
  addRelatedParesOfSelectedToDiagnose({ state, dispatch }) {
    dispatch(
      "diagnosis/addRelatedParesToAddedPotentialSpace",
      {
        relatedParesIds: state.relatedParesOfSelected,
        id: state.selected.id,
      },
      { root: true }
    );
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
